import { render, staticRenderFns } from "./CollectionFilterFieldsMenu.vue?vue&type=template&id=ca9320b6"
import script from "./CollectionFilterFieldsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterFieldsMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports